/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DimensionEnum } from "./DimensionEnum";
import {
  DimensionEnumFromJSON,
  DimensionEnumFromJSONTyped,
  DimensionEnumToJSON,
  DimensionEnumToJSONTyped,
} from "./DimensionEnum";
import type { BoundaryConditionTypeEnum } from "./BoundaryConditionTypeEnum";
import {
  BoundaryConditionTypeEnumFromJSON,
  BoundaryConditionTypeEnumFromJSONTyped,
  BoundaryConditionTypeEnumToJSON,
  BoundaryConditionTypeEnumToJSONTyped,
} from "./BoundaryConditionTypeEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface BoundaryCondition
 */
export interface BoundaryCondition {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  boundaryId: number;
  /**
   *
   */
  readonly threedimodel?: string;
  /**
   *
   */
  type: BoundaryConditionTypeEnum;
  /**
   *
   */
  dimension: DimensionEnum;
}

/**
 * Check if a given object implements the BoundaryCondition interface.
 */
export function instanceOfBoundaryCondition(value: object): value is BoundaryCondition {
  if (
    (!("boundaryId" in (value as Record<string, any>)) &&
      !("boundary_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["boundaryId"] === undefined &&
      (value as Record<string, any>)["boundary_id"] === undefined)
  )
    return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("dimension" in value) || value["dimension"] === undefined) return false;
  return true;
}

export function BoundaryConditionFromJSON(json: any): BoundaryCondition {
  return BoundaryConditionFromJSONTyped(json, false);
}

export function BoundaryConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BoundaryCondition {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    boundaryId: json["boundary_id"],
    threedimodel: json["threedimodel"] == null ? undefined : json["threedimodel"],
    type: BoundaryConditionTypeEnumFromJSON(json["type"]),
    dimension: DimensionEnumFromJSON(json["dimension"]),
  };
}

export function BoundaryConditionToJSON(json: any): BoundaryCondition {
  return BoundaryConditionToJSONTyped(json, false);
}

export function BoundaryConditionToJSONTyped(
  value?: Omit<BoundaryCondition, "id" | "url" | "threedimodel"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    boundary_id: value["boundaryId"],
    type: BoundaryConditionTypeEnumToJSON(value["type"]),
    dimension: DimensionEnumToJSON(value["dimension"]),
  };
}
